export default __webpack_public_path__ + "static/media/36I-120857_-43993_0.f8169c50.jpg";